let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lAyi1")).then(() => parcelRequire('isk33'));